/**
 * Shared placeholder values used by preview and fallback rendering.
 */

export class Placeholders {
    public static TEXT_ONLY = "TEXT ONLY";
    public static NO_IMAGE = "";
    // Admin/editor-only debug indicator: every image/video in a post's media area
    // 404'd (the post DOES have attached_images/attached_videos data, unlike the
    // genuinely-no-media TEXT_ONLY case) — see board-media-image-error-render.ts.
    public static MEDIA_404 = "404";
}
